import React, {forwardRef} from 'react'
import {Swiper as BaseSwiper, SwiperSlide} from 'swiper/react'
import {SwiperBaseStyles} from '../_app/partials/SwiperBaseStyles'

/**
 * Swiper plus its 22KB stylesheet, so the CSS loads with the few components that
 * use a carousel instead of on every page. Emotion dedupes the Global by hash,
 * so several Swipers on one page still insert it once.
 */
export const Swiper = forwardRef((props, ref) => (
    <>
        <SwiperBaseStyles />
        <BaseSwiper ref={ref} {...props} />
    </>
))

Swiper.displayName = 'Swiper'

export {SwiperSlide}
